import axiosConfig from "./axiosConfig";

export type GprTerm =
  | { type: "flat"; valuePct: number }
  | { type: "fractionOfDesignedPr"; fraction: number }
  | { type: "designedPrMinus"; deltaPct: number };

export type GprRule =
  | GprTerm
  | { type: "max"; terms: [GprTerm, GprTerm] }
  | { type: "min"; terms: [GprTerm, GprTerm] };

export interface SiteHealthConfig {
  siteId: string;
  alertingEnabled: boolean;
  unreliableConnection: boolean;
  lateDataThresholdSeconds: number;
  contractedAvailability: number | null;
  /** @deprecated replaced by designedPrPct + gprRule; retained during transition */
  contractedGpr: number | null;
  designedPrPct: number | null;
  gprRule: GprRule | null;
  weatherActualsEnabled: boolean;
  /** Reduxi-only grid-import limits (kW), both optional. See the import-limit
   * health check. maxImportEnforcedKw must be <= maxImportAllowedKw when both set. */
  maxImportAllowedKw: number | null;
  maxImportEnforcedKw: number | null;
  createdAt: string;
  updatedAt: string;
}

const getSiteHealthConfig = async (
  authToken: string,
  siteId: string
): Promise<SiteHealthConfig | null> => {
  const { data } = await axiosConfig.get(`/site/${siteId}/health/config`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  // BMA returns `{healthConfig: null}` (200) when the site has no health
  // config — a legitimate state, not an error. Normalise to null for callers.
  if (data == null || data.healthConfig === null) {
    return null;
  }
  return data;
};

export default getSiteHealthConfig;
